<template>
  <div class="header">
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
     
    />
    <!-- 修改图片展示 -->
    <van-row>
      <van-uploader
      class="uploader"
        v-if="editing"
        @delete="fileDelete"
        :max-count="1"
        v-model="fileList"
        :after-read="afterRead"
      >
      </van-uploader>
      <!-- 详情图片展示 -->
      <van-image
        v-else
        fit="cover"
        class="image"
        :src="params.cookbookUrl ? params.cookbookUrl : errorUrl"
      />
    </van-row>
    <!-- 修改页面 -->
    <van-row v-if="editing">
      <van-field v-model="params.name" placeholder="请输入" input-align="left">
        <template #label> 菜谱名称<van-icon name="edit" /> </template>
      </van-field>
      <van-field
        v-model="params.estimateTime"
        placeholder="请输入"
        input-align="left"
      >
        <template #label> 预计时间<van-icon name="edit" /> </template>
        <template #right-icon>分钟左右</template>
      </van-field>
    </van-row>
    <!-- 详情页面 -->
    <van-row class="detail_my" v-else>
      <div >
        <span class="text_ccc fSize_18 goods_over float_left"  >{{
          params.name
        }}</span>
        <span class="text_yellow fSize_20 float_right" style="text-align: right"
          >￥{{ params.unitPrice | filterNumTwo }}/<span class="fSize_14">份</span></span
        >
      </div>
      <van-row style="margin-top: 6px" class="fSize_12 text_ccc"
        >{{ params.estimateTime }}分钟左右</van-row
      >
    </van-row>
    <ingredients
      ref="ingredients"
      v-if="ingFalg > 0 && editing"
      :info="params"
    />
    <detilIndre v-if="ingFalg && !editing" :info="params" />
    <van-row class="sure_bom" type="flex" justify="end">
      <!-- 修改 -->
      <van-col v-if="editing">
        <van-button
          v-if="editing"
          round
          color="rgba(102, 102, 102, 1)"
          plain
          @click="cancel"
          size="small"
          >取消</van-button
        >
        <van-button
          v-if="editing"
          round
          type="info"
          size="small"
          color="rgb(116, 180, 43)"
          @click="setCookbook"
          >保存</van-button
        >
      </van-col>
      <van-col
        style="display: flex"
        v-else-if="this.$route.query.remark == 'my'"
      >
        <van-button @click="editing = true" round type="info" size="small" plain color="#666666"
          >修改</van-button
        >
        <div @click="carShow = true" class="addCar fSize_14">
          一键加车
        </div>
      </van-col>
      <div style="width:100%" v-else>
        <van-button class="float_left" round type="info" @click="copyId" size="small" plain color="#666666"
          >复制</van-button
        >
        <div @click="choseShow = true" class="addCar float_right fSize_14">
          选购食材
        </div>
      </div>
    </van-row>
    <van-popup  lock-scroll :close-on-click-overlay='false'  round position="bottom"  :style="{height: '80%',overflow:'hidden'}" v-model="carShow">
    <commonCar v-if="carShow" @close='carShow = false'></commonCar>
   </van-popup>
   <van-popup  lock-scroll :close-on-click-overlay='false'  round position="bottom"  :style="{height: '80%',overflow:'hidden'}" v-model="choseShow">
    <commonChose @close='choseShow = false'  :info="params"  v-if="choseShow"></commonChose>
   </van-popup>
  </div>
</template>
<script>
import ingredients from "./tpl/ingredients";
import detilIndre from "./tpl/detilIndre";
import commonCar from "./tpl/commonCar";
import commonChose from "./tpl/commonChose";

export default {
  components: {
    ingredients,
    detilIndre,
    commonCar,
    commonChose
  },
  created() {
    this.editing = this.$route.path.indexOf("detailMenu") != -1 ? false : true;
    this.cookbookId = this.$route.query.cookbookId;
    if (this.cookbookId) {
      this.getDetails();
    } else {
      this.ingFalg = true;
    }
  },
  data() {
    return {
      editing: true,
      dataList: [],
      cookbookId: "",
      choseShow: false,
      carShow: false,
      params: {
        name: "",
        cookbookUrl: "",
        estimateTime: "",
        tradeCookbookDtlDTOS: [],
        unitPrice: ""
      },
      ingFalg: false,
      errorUrl: require("@/assets/头像图片.png"),
      fileList: []
    };
  },
  watch: {},
  methods: {
    cancel() {
      if (this.cookbookId) {
        this.editing = false;
      } else {
        this.$router.push({
          path: "/menuList",
          query: {
            activeTitle: 1
          }
        });
      }
    },
    copyId() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认复制？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          this.ingFalg = false;
          // on confirm
          this.$axios
            .get(`trade/tradeCookbook/copy/${this.cookbookId}`)
            .then(res => {
              this.$toast.success("复制成功");
              if (res.data) {
                this.$router.replace({
                  path: "/menuList/detailMenu",
                  query: {
                    cookbookId: this.cookbookId,
                    remark: "my"
                  }
                });
                this.ingFalg = true;
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    setCookbook() {
      //主料
      let mainInfo = this.$refs.ingredients.tradeCookbookDtlDTOS.filter(
        item => {
          return item.classifyValue == 0;
        }
      );
      if (mainInfo.length == 0) {
        return this.$toast.fail("主辅料商品必填");
      }
      for (const key of this.$refs.ingredients.tradeCookbookDtlDTOS) {
        if (!key["parameter"]) {
          return this.$toast("请输入数量");
        }
      }
      if (!this.params["cookbookUrl"]) {
        return this.$toast.fail("菜谱图片必填");
      } else if (!this.params["name"]) {
        return this.$toast.fail("菜谱名称必填");
      } else if (!this.params["estimateTime"]) {
        return this.$toast.fail("预计时间必填");
      }
      let paramsVal = {
        ...this.params,
        tradeCookbookDtlDTOS: this.$refs.ingredients.tradeCookbookDtlDTOS
      };
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认保存？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          // on confirm // cookbookId
          this.$axios.post("trade/tradeCookbook/save", paramsVal).then((res) => {
            // this.$router.push({
            //   path: "/menuList/detailMenu",
            //   query: {
            //     cookbookId: this.params.cookbookId,
            //     remark: "my"
            //   }
            // });
            this.editing = false;
            this.$toast.success("保存成功");
            this.cookbookId = res.data.data; 
            this.getDetails()
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getDetails() {
      this.ingFalg = false;
      this.$axios.get(`trade/tradeCookbook/${this.cookbookId}`).then(res => {
        this.params = res.data.data;
        this.params.tradeCookbookDtlDTOS.forEach(item => {
          item.orderQty = item.orderQty == null ? 0 : item.orderQty;
        });
        this.ingFalg = true;
        if (res.data.data.cookbookUrl) {
          this.fileList = [
            {
              url: res.data.data.cookbookUrl
            }
          ];
        } else {
          this.fileList = [];
        }
      });
    },
    fileDelete() {
      this.params.cookbookUrl = "";
    },
    onClickLeft() {
      this.$router.push({
        path: "/menuList",
        query: {
          activeTitle: this.$route.query.remark == "recom" ? 0 : 1
        }
      });
    },
    afterRead(newFile) {
      let { file } = newFile;
      newFile.status = "uploading";
      newFile.message = "上传中...";
      //$post(``, params)
      let data = new FormData();
      data.append("file", file, file.name);
      data.append("type", "menu");
      this.$axios
        .post("sys/tool/uploadFile", data)
        .then(res => {
          this.params.cookbookUrl = res.data.data;
          newFile.status = "success";
          newFile.message = "上传成功";
        })
        .catch(() => {
          newFile.status = "fail";
          newFile.message = "上传失败";
        });
    },
    formatter(type, val) {
      if (type == "hour") {
        return `${+val}时`;
      } else if (type == "minute") {
        return `${+val}分`;
      }
      return val;
    }
  }
};
</script>

<style lang='scss' scoped>
.image.van-image {
  height: 50vh;
  width: 100%;
}
/deep/ .van-nav-bar .van-icon {
  color: rgb(116, 180, 43);
}
/deep/ .van-nav-bar__text {
  color: rgb(116, 180, 43);
}
/deep/ .uploader.van-uploader {
  height: 50vh;
  width: 100%;
  /deep/ .van-uploader__wrapper {
    height: 100%;
  }
}
.uploader /deep/ .van-uploader__upload {
  width: 100%;
  height: 50vh;
}
.uploader /deep/ .van-uploader__preview {
  width: 100% !important;
  .van-uploader__preview-image {
    height: 50vh;
    width: auto;
  }
}

// /deep/ .van-uploader {
//   width: 100%;
//   height: 354px;
//   /deep/ .van-uploader__wrapper {
//     width: 100%;
//     height: 354px;
//   }
//   /deep/ .uploader.van-uploader__upload {
//     width: 100%;
//     height: 354px;
//   }
//   /deep/ .van-uploader__preview {
//     width: 100%;
//     height: 100%;
//     /deep/ .van-uploader__preview-image {
//       width: 100%;
//       height: 50vh;
//       /deep/ .van-image__img {
//         object-fit: contain !important;
//       }
//     }
//   }
// }

.header {
  padding: 48px 0 53px 0;
}
.header /deep/ .van-nav-bar {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.text_yellow {
  /deep/ .van-field__control {
    width: 100%;
    color: rgba(245, 166, 35, 1);
  }
}
.detail_my {
  background-color: #fff;
  padding: 10px 16px;
  div {
    overflow: hidden;
  }
}
.addCar {
  background-image: url(imgs/矩形1.png);
  background-size: 100%;
  width: 104px;
  text-align: center;
  height: 32px;
  color: #fff;
  background-repeat: no-repeat;
  margin-left: 12px;
}
</style>